import React from 'react';
import { customerStatusSkin } from '../../lib/customer-status';

/** The saturated status badge — dark ink on the signal fill, as the register idiom asks. */
export function CustomerStatusBadge({ status, className = '' }: { status: unknown; className?: string }) {
  const skin = customerStatusSkin(status);
  return (
    <span
      data-testid="customer-status-badge"
      className={`inline-flex w-fit items-center whitespace-nowrap rounded-fi-pill border border-black/20 px-2.5 py-1 text-[0.68rem] font-black uppercase tracking-[0.06em] leading-none text-fi-signal-ink ${skin.fill} ${className}`}
    >
      {skin.label}
    </span>
  );
}

export default CustomerStatusBadge;
